<template>
	<div class="firstCard" :style="{ position: isTip ? 'relative' : 'unset' }">
		<img v-if="!isTip" style="width: 1280px; height: 433px; position: relative; left: -40px; top: -40px;" src="../../../assets/icon_dean_home_bg_card_1.png" alt="" />
		<img v-if="isTip" style="width: 1280px; height: 433px; position: absolute; left: -40px; top: -40px;" src="../../../assets/icon_dean_home_bg_card_1_1.png" alt="" />
		<div style="position: absolute; width: 1200px; height: 353px;">


			<div style="display: flex; flex-direction: column; width: 100%; height: 100%;" :style="{pointerEvents: isTip ? 'none' : 'unset'}">
				<div style="display: flex; height: 39px; justify-content: space-between;">
					<div style="display: flex; align-items: center; align-self: flex-end;">
						<div style="width: 5px; height: 20px; background: #4A7CE8; border-radius: 0px 3px 3px 0px"></div>
						<div style="font-size: 18px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #1F2635; line-height: 24px; margin-left: 15px;">当日需及时关心的长者</div>
						<div style="display: flex; align-items: center; margin-left: 5px;" :style="{opacity: !data ? 0 : 1}">
							<img style="width: 7px; height: 8px; z-index: 1;" src="../../../assets/icon_common_special_arrow_1.png" alt="" />
							<div style="margin-left: -2px; background: #FFE4E8; border-radius: 4px; border: 1px solid #FED3D9; padding: 2px 5px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #FF7186; line-height: 20px;">{{ dataLength + '位' }}</div>
						</div>
					</div>
					<div v-if="data && dataLength > 0" style="display: flex; align-items: center; align-self: flex-end; margin-bottom: 7px;">
						<img style="width: 73px; height: 14px; margin-right: 10px;" src="../../../assets/icon_dean_home_bg_card_icon_1.png" alt="" />
						<div style="display: flex; align-items: center; margin-right: 20px;" @click="seeAll()">
							<div style="font-size: 16px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 22px; margin-right: 2px; cursor: pointer;">查看全部</div>
							<img style="width: 16px; height: 16px;" src="../../../assets/icon_dean_home_bg_card_icon_8.png" alt="" />
						</div>
					</div>
				</div>
				<div v-if="!data" style="width: 1160px; height: 274px; background: #ECF0F3; box-shadow: inset 8px 8px 20px 0px #D1D9E6, inset -8px -8px 20px 0px #FFFFFF; border-radius: 16px; margin-top: 20px; margin-left: 20px; display: flex; justify-content: center; align-items: center; flex-direction: column;">
					<img v-if="emptyString != '院长端未关联任何设备'" style="width: 107px; height: 107px; z-index: 1;" :src="require(emptyString == '所有设备离线，请尽快检查设备情况，恢复守护状态' ? '../../../assets/icon_dean_home_card_empty_icon_1.png' : emptyString == '设备赶紧用起来才能看到更多内容哦' ? '../../../assets/icon_dean_home_card_empty_icon_2.png' : '../../../assets/icon_dean_home_card_empty_icon_3.png')" alt="" />
					<div v-if="emptyString != '院长端未关联任何设备'" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #A4ABB6; line-height: 20px; margin-top: 15px;">{{ emptyString || ' ' }}</div>
				</div>
				<div v-if="data" style="height: 314px; display: flex; flex-direction: column;">
					<div style="height: 234px; position: relative;">
						<div style="height: 100%; position: absolute; z-index: 0; width: 100%;">
							<el-carousel :interval="5000000" arrow="never" height="234px" :loop="false" indicator-position='none' ref="homeDeanFirstCardRef" @change="carouselChange" >
								<el-carousel-item v-for="(item,index) in data || []" :key="index" >
									<div style="width: 100%; height: 100%; display: flex; padding-left: 20px;">
										<div class="miniCardHover" @click="itemClick(subItem)" v-for="(subItem,subIndex) in item || []" style="width: 220px; height: 199px; box-shadow: 5px 5px 8px 0px #D1D9E6, -5px -5px 8px 0px #FFFFFF; border-radius: 16px; display: flex; flex-direction: column;" :style="{marginRight: subIndex == 4 ? '0px' : '15px'}">
											<div style="flex: 1; display: flex; position: relative; justify-content: center;">
												<div style="flex: 1; margin-bottom: 10px; margin-left: 5px; margin-right: 5px; margin-top: 5px; background: #FAF3F6; border-radius: 12px; border: 1px solid #FED3D9; display: flex; flex-direction: column;">
													<div class="richTextDiv" style="flex: 1; display: flex; flex-direction: column; padding-left: 10px; padding-right: 10px;">
														<div 
														class="description"
														v-if="miniIndex <= 1" 
														v-for="(miniItem, miniIndex) in subItem.eventTextList || []" 
														style="background: #FEE7EB; border-radius: 8px; height: 40px; margin-top: 10px; display: flex; align-items: center; position: relative;"
														>
															<!-- <div v-html="$options.filters.reMate(miniItem)" style="width: 170px; margin-left: 10px;"></div>
															<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: 30px; padding: 10px; border-radius: 8px; display: none;" :style="{left: subIndex == 4 ? '-50%' : '50%'}">
																<div v-html="$options.filters.reMate(miniItem)"></div>
															</div> -->
															<div v-html="$options.filters.reMate(miniItem)" style="width: 170px; margin-left: 10px;"></div>
															<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; top: 30px; padding: 10px; border-radius: 8px; display: none;" :style="{transform: subIndex == 4 ? 'translateX(-94px)' : 'translateX(94px)'}">
																<div v-html="$options.filters.reMateNewNew(miniItem)"></div>
															</div>
														</div>
													</div>
													<div style="display: flex; height: 34px; justify-content: space-between; margin-bottom: 10px; padding-left: 10px; padding-right: 10px;">
														<div style="width: 38px; height: 24px; background: rgba(94, 103, 121, 0.1); border-radius: 19px 19px 19px 2px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; display: flex; align-items: center; padding-left: 8px;" :style="{opacity: subItem && subItem.eventTextList && subItem.eventTextList.length > 2 ? 1 : 0}">…</div>
														<div style="width: 58px; height: 30px; background: rgba(74, 124, 232, 0.15); border-radius: 20px; font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 600; color: #4A7CE8; line-height: 20px; display: flex; justify-content: center; align-items: center; align-self: flex-end;">查看</div>
													</div>
												</div>
												<img style="position: absolute; width: 16px; height: 12px; bottom: 0px;" src="../../../assets/icon_common_special_arrow_5.png" alt="" />
											</div>
											<div class="bedName" style="display: flex; margin-bottom: 10px; align-items: center; justify-content: center; padding-left: 10px; padding-right: 10px; position: relative;">
												<div class="miniCardHoverImg" style="width: 20px; height: 20px; margin-right: 5px;" alt=""></div>
												<div class="miniCardHoverText" style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 175px;">{{ subItem.bedName || '' }}</div>
												<div class="showDescription" style="position: absolute; background: #FFFFFF; z-index: 1000; bottom: 25px; padding: 10px; border-radius: 8px; display: none; z-index: 10000;" :style="{transform: subIndex == 4 ? 'translateX(-50%)' : 'translateX(50%)'}">
													<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; line-height: 20px; white-space: wrap; overflow-wrap: break-word; color: rgba(94, 103, 121, 1);">{{ subItem.bedName || '' }}</div>
												</div>
											</div>
										</div>
									</div>
								</el-carousel-item>
							</el-carousel>
						</div>
						<img 
						style="position: absolute; width: 96px; height: 96px; left: -5px; top: 75px; z-index: 1; cursor: pointer;"
						:src="require('../../../assets/' + (leftBtnState == 1 ? 'icon_dean_home_bg_card_icon_12' : 'icon_dean_home_bg_card_icon_11') + '.png')" 
						onselectstart="return false" 
						alt=""
						@click="clickArrow(1)"
						v-if="currentPage != 1"
						@mouseover="leftBtnHover"
						@mouseout="leftBtnRemoveHover"
						/>
						<img 
						style="position: absolute; width: 96px; height: 96px; right: -5px; top: 75px; z-index: 1; cursor: pointer;"
						:src="require('../../../assets/' + (rightBtnState == 1 ? 'icon_dean_home_bg_card_icon_14' : 'icon_dean_home_bg_card_icon_13') + '.png')" 
						onselectstart="return false" 
						alt=""
						@click="clickArrow(2)"
						v-if="currentPage != data.length"
						@mouseover="rightBtnHover"
						@mouseout="rightBtnRemoveHover"
						/>
					</div>
					<div style="display: flex; margin-left: 20px; justify-content: space-between; align-items: center;">
						<div style="background: rgba(255,255,255,0.8); border-radius: 16px; border: 1px solid #FFFFFF; height: 60px; position: relative; display: flex; align-items: center;">
							<img style="width: 20px; height: 20px; position: absolute; left: -3px; top: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_9.png" alt="" />
							<img style="width: 20px; height: 20px; position: absolute; right: -3px; bottom: -3px;" src="../../../assets/icon_dean_home_bg_card_icon_10.png" alt="" />
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_2.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">与长者沟通身体情况</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_3.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">测量体温、血压、呼吸、心跳</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_4.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px;">提供理疗等健康改善服务，有效控制疾病恶化</div>
							<div style="width: 1px; height: 20px; background: #D5DADF; margin-left: 15px;"></div>
							<img style="width: 22px; height: 22px; margin-left: 20px;" src="../../../assets/icon_dean_home_bg_card_icon_5.png" alt="" />
							<div style="font-size: 14px; font-family: PingFangSC, PingFang SC; font-weight: 400; color: #5E6779; line-height: 20px; margin-left: 5px; margin-right: 20px;">陪诊去医院检查</div>
						</div>
						<div class="exportTodayPlan" style="background: rgba(74, 124, 232, 0.15); display: flex; height: 40px; margin-right: 20px; display: flex; justify-content: center; align-items: center; padding-left: 15px; padding-right: 15px; border-radius: 20px; cursor: pointer;" @click="clickExportAllWorkPlan">
							<img style="width: 16px; height: 16px; margin-right: 2px;" src="../../../assets/icon_home_first_card_export_icon.png" alt="" />
							<div style="font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #497AE5; line-height: 20px;">导出当日工作计划</div>
						</div>
					</div>
				</div>
			</div>


		</div>
		

		<div v-if="isTip" style="position: absolute; top: 363px; left: 336px; display: flex; flex-direction: column; align-items: center;">
			<img style="width: 38px; height: 12px;" src="../../../assets/icon_home_hei_san_jiao_1.png" alt="" />
			<div style="width: 529px; background: #5E6779; border-radius: 8px; padding-left: 20px; padding-right: 20px; padding-top: 20px; padding-bottom: 15px;">
				<div style="background: rgba(255, 255, 255, 0.1); border-radius: 6px; padding-left: 15px; padding-right: 15px; padding-top: 10px; padding-bottom: 10px; position: relative;">
					<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF00; line-height: 24px; width: 100%; white-space: wrap;">
						·红区老人是每日必须重点关注的：只需要每天花3～5分钟时间，就能大概了解到昨晚有哪些老人发生了哪些异常表现（例如：发生呼吸过速报警的老人、日常呼吸发生变化的老人等）。
					</div>
					<div style="position: absolute; height: 8px; background: rgba(255, 113, 134, 0.3); left: 105px; top: 25px; width: 126px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(255, 113, 134, 0.3); left: 80px; top: 73px; width: 95px; height: 8px;"></div>
					<div style="position: absolute; height: 8px; background: rgba(255, 113, 134, 0.3); left: 272px; top: 73px; width: 94px; height: 8px;"></div>
					<div style="position: absolute; font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 16px; color: #FFFFFF; line-height: 24px; left: 15px; top: 10px; right: 15px;">
						·红区老人是每日必须重点关注的：只需要每天花3～5分钟时间，就能大概了解到昨晚有哪些老人发生了哪些异常表现（例如：发生呼吸过速报警的老人、日常呼吸发生变化的老人等）。
					</div>
				</div>
				<div style="margin-top: 15px; display: flex; justify-content: space-between; align-items: center;">
					<div style="display: flex;">
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px;">1/3</div>
						<div style="font-family: PingFangSC, PingFang SC; font-weight: 200; font-size: 14px; color: rgba(255, 255, 255, 0.5); line-height: 24px; margin-left: 15px; cursor: pointer;" @click="skippingTutorial">跳过教程</div>
					</div>
					<div style="width: 72px; height: 30px; background: #4A7CE8; border-radius: 20px; font-family: PingFangSC, PingFang SC; font-weight: 600; font-size: 14px; color: #FFFFFF; line-height: 20px; display: flex; align-items: center; justify-content: center; cursor: pointer;" @click="next">下一步</div>
				</div>
			</div>
		</div>
		
		<FirstCardAllAlert ref="firstCardAllAlert" @itemClick="itemClick"></FirstCardAllAlert>
		<WorkProposalAlert ref="firstCardWorkProposalAlert" :type="0"></WorkProposalAlert>

		<div v-if="isShowExportingLoading" style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); z-index: 99999;">
			<a-spin size="large" tip="全力导出中，请稍候..." />
		</div>
	</div>
</template>
  
<script>
import FirstCardAllAlert from './firstCardAllAlert.vue'; 
import WorkProposalAlert from './workProposalAlert.vue'
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
	components: {
		FirstCardAllAlert,
		WorkProposalAlert
	},
	filters: {
		reMate(val){
			return CustomRichText.reMateNew(portFn.function_reg_str_to_arr(val))
		},
		reMateNewNew(val){
			return CustomRichText.reMateNewNew(portFn.function_reg_str_to_arr(val))
		},
	},
	props: {
		data: {
			type: Array,
			default: null
		},
		dataLength: {
			type: Number,
			default: 0
		},
		emptyString: {
			type: String,
			default: null
		},
		isTip: {
			type: Boolean,
			default: false
		}
	},
	watch: {
	},
	data() {
		return {
			leftBtnState: 0,
			rightBtnState: 0,
			currentPage: 1,
			hoverText: null,
			isShowExportingLoading: false
		};
	},
	created() { },
	mounted() {

	},
	methods: {
		clickExportAllWorkPlan() {
			console.log('===点击了导出===')
			this.exportWorkPlan();
		},
		exportAllWorkPlan() {

		},
		exportWorkPlan() {
			let param = {};
			this.isShowExportingLoading = true;
			this.$get(
				'api/dean/v5/timelyCareElderExport',
				param,
				(res) => {
					this.isShowExportingLoading = false;
					if (res.code == 0) {
						var a = document.createElement('a'); //创建一个<a></a>标签
						a.href = `/api/dean/v5/downloadFile?filePath=${res.data}`;
						a.style.display = 'none'; // 障眼法藏起来a标签
						document.body.appendChild(a); // 将a标签追加到文档对象中
						a.click(); // 模拟点击了a标签，会触发a标签的href的读取，浏览器就会自动下载了
						a.remove(); // 一次性的，用完就删除a标签
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					this.isShowExportingLoading = false;
					// this.$message.error('服务端发生异常');
				}
			);
		},
		carouselChange(){
			let activeIndex = this.$refs.homeDeanFirstCardRef.activeIndex
      		this.currentPage = Number(activeIndex + 1)
		},
		clickArrow(type) {
			if(type == 1){
				this.$refs.homeDeanFirstCardRef.prev()
			}else {
				this.$refs.homeDeanFirstCardRef.next()
			}
		},
		leftBtnHover() {
			this.leftBtnState = 1;
			this.rightBtnState = 0;
		},
		leftBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		rightBtnHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 1;
		},
		rightBtnRemoveHover() {
			this.leftBtnState = 0;
			this.rightBtnState = 0;
		},
		seeAll() {
			this.$refs.firstCardAllAlert.openAlert()
		},
		itemClick(item) {
			this.$refs.firstCardWorkProposalAlert.openAlert(item)
		},
		// 跳过教程
		skippingTutorial() {
			this.$emit('skippingTutorial', 1);
		},
		// 下一步
		next() {
			this.$emit('next', 1);
		}
	},
};
</script>
<style lang="scss" scoped>
.firstCard {
	height: 353px;
	position: unset;
	display: flex;
	margin-top: 30px;
	margin-bottom: 0px;
}
.miniCardHover {
	margin-top: 20px;
	background: #ECF0F3;
	cursor: pointer;
	.miniCardHoverText {
		color: #5E6779;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_6.png') no-repeat no-repeat;
		background-size: contain;
	}
}
.miniCardHover:hover {
	background: #DFE8FC;
	.miniCardHoverText {
		color: #4A7CE8;
	}
	.miniCardHoverImg {
		background: url('../../../assets/icon_dean_home_bg_card_icon_7.png') no-repeat no-repeat;
		background-size: contain;
	}
}

.richTextDiv ::v-deep {
	.richContentStyle {
		display: block;
		white-space: nowrap;
		height: 20px;
		text-overflow: ellipsis;
		overflow: hidden;
	}
	.richTextStyleNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}
	.richTextStyleRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		white-space: nowrap;
		display: inline;
	}

	.richContentStyleTip {
		display: block;
		white-space: wrap;
		// max-width: 100px;
		overflow-wrap: break-word;
	}
	.richTextStyleTipNormal {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: #5E6779;
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
	.richTextStyleTipRed {
		font-size: 14px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		color: rgba(255, 113, 134, 1);
		line-height: 20px;
		// white-space: nowrap;
		display: inline;
	}
}
// transform: translateX(50%);
.description:hover {
	.showDescription {
		display: block !important;
		// transform: translateX(-50%);
	}
}

.bedName:hover {
	.showDescription {
		display: block !important;
	}
}

.exportTodayPlan:hover {
	background: rgba(74, 124, 232, 0.25) !important;
}

</style>
  